import { supabase } from '../lib/supabase';

/**
 * 현재 사용자가 관리자인지 확인
 */
export const checkAdminAccess = async () => {
  try {
    const { data, error } = await supabase.rpc('is_admin');
    
    if (error) {
      console.error('관리자 권한 확인 실패:', error);
      return false;
    }
    
    return data === true;
  } catch (error) {
    console.error('관리자 권한 확인 중 오류:', error);
    return false;
  }
};

/**
 * 현재 사용자의 역할 가져오기
 */
export const getUserRole = async () => {
  try {
    const { data, error } = await supabase.rpc('get_user_role');
    
    if (error) {
      console.error('사용자 역할 조회 실패:', error);
      return 'user';
    }
    
    return data || 'user';
  } catch (error) {
    console.error('사용자 역할 조회 중 오류:', error);
    return 'user';
  }
};

/**
 * 관리자 전용: 모든 사용자 목록 가져오기
 */
export const getAllUsersAdmin = async () => {
  try {
    const { data, error } = await supabase.rpc('get_all_users_admin');
    
    if (error) {
      console.error('사용자 목록 조회 실패:', error);
      throw error;
    }
    
    // 각 사용자의 session_stats가 정의되어 있는지 확인하고 기본값 설정
    const usersWithDefaults = (data || []).map(user => ({
      ...user,
      session_stats: user.session_stats || {
        totalSessions: 0,
        activeSessions: 0,
        completedSessions: 0,
        averageProgress: 0
      }
    }));
    
    return usersWithDefaults;
  } catch (error) {
    console.error('사용자 목록 조회 중 오류:', error);
    throw error;
  }
};

/**
 * 관리자 전용: 사용자 통계 가져오기
 */
export const getUserStatsAdmin = async () => {
  try {
    const { data, error } = await supabase.rpc('get_user_stats_admin');
    
    if (error) {
      console.error('사용자 통계 조회 실패:', error);
      throw error;
    }
    
    // 데이터가 null이거나 undefined인 경우 기본값 반환
    const defaultStats = {
      totalUsers: 0,
      usersWithProfiles: 0,
      inProgressSessions: 0,
      completedSessions: 0,
      activeSessions: 0,
      newUsersThisWeek: 0,
      newUsersToday: 0
    };
    
    return data ? { ...defaultStats, ...data } : defaultStats;
  } catch (error) {
    console.error('사용자 통계 조회 중 오류:', error);
    throw error;
  }
};

/**
 * 관리자 권한이 필요한 작업을 실행하기 전에 권한 확인
 */
export const requireAdminAccess = async () => {
  const isAdmin = await checkAdminAccess();
  
  if (!isAdmin) {
    throw new Error('관리자 권한이 필요합니다.');
  }
  
  return true;
};
